import React from 'react';
import { X, CheckCircle, AlertCircle, Info } from 'lucide-react';
import { useToast } from '../context/ToastContext';
import './ToastContainer.css';

const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) return null;

  const getIcon = (type: string) => {
    switch (type) {
      case 'success':
        return <CheckCircle size={18} />;
      case 'error':
        return <AlertCircle size={18} />;
      case 'info':
        return <Info size={18} />;
      default:
        return <CheckCircle size={18} />;
    }
  };

  // Group toasts by position
  const topRightToasts = toasts.filter(toast => !toast.position || toast.position === 'top-right');
  const bottomRightToasts = toasts.filter(toast => toast.position === 'bottom-right');
  const topRightFavoritesToasts = toasts.filter(toast => toast.position === 'top-right-favorites');

  return (
    <>
      {/* Top-right toasts (default) */}
      {topRightToasts.length > 0 && (
        <div className="toast-container toast-container-top-right">
          {topRightToasts.map((toast) => (
            <div
              key={toast.id}
              className={`toast toast-${toast.type}`}
            >
              <div className="toast-icon">
                {getIcon(toast.type)}
              </div>
              <span className="toast-message">{toast.message}</span>
              <button
                className="toast-close"
                onClick={() => removeToast(toast.id)}
              >
                <X size={16} />
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Bottom-right toasts (from floating player) */}
      {bottomRightToasts.length > 0 && (
        <div className="toast-container toast-container-bottom-right">
          {bottomRightToasts.map((toast) => (
            <div
              key={toast.id}
              className={`toast toast-${toast.type}`}
            >
              <div className="toast-icon">
                {getIcon(toast.type)}
              </div>
              <span className="toast-message">{toast.message}</span>
              <button
                className="toast-close"
                onClick={() => removeToast(toast.id)}
              >
                <X size={16} />
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Top-right favorites toasts (from My Favorites menu) */}
      {topRightFavoritesToasts.length > 0 && (
        <div className="toast-container toast-container-top-right-favorites">
          {topRightFavoritesToasts.map((toast) => (
            <div
              key={toast.id}
              className={`toast toast-${toast.type} toast-favorites`}
            >
              <div className="toast-icon">
                {getIcon(toast.type)}
              </div>
              <span className="toast-message">{toast.message}</span>
              <button
                className="toast-close"
                onClick={() => removeToast(toast.id)}
              >
                <X size={16} />
              </button>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default ToastContainer;